/**
 * The public address of the API, for the developer examples the console shows
 * (curl snippets, trigger URLs). Production bakes it in at build time; in dev
 * it is the gateway's port on the same host as the page.
 */
export function publicApiUrl(): string {
  const fromBuild = import.meta.env.VITE_PUBLIC_API_URL;
  if (fromBuild) return fromBuild.replace(/\/+$/, '');
  if (typeof window === 'undefined') return 'https://api.example.com';
  return window.location.origin.replace(/:\d+$/, ':18080');
}
